var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap"},[(_vm.mapping)?_c('v-icon',{attrs:{"small":"","title":_vm.$t(_vm.mapping.title)}},[_vm._v("\n        "+_vm._s(_vm.mapping.ico)+"\n    ")]):_c('v-chip',{staticClass:"mr-1 mt-1",attrs:{"x-small":""},domProps:{"textContent":_vm._s(_vm.groupName)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }